import {apiGetCall, apiPostCall} from "./index";

export const load            = () => apiGetCall("/groups/getall");
export const save            = (uuid, groupDetails) => apiPostCall("/groups/save", {uuid, ...groupDetails});
export const remove          = uuid => apiPostCall("/groups/remove", {uuid});
export const addCaretakers   = (group, caretakers) => apiPostCall("/groups/addcaretakers", {group, caretakers});
export const removeCaretaker = (group, caretaker) => apiPostCall("/groups/removecaretaker", {group, caretaker});

export const manageSave       = (uuid, groupDetails) => apiPostCall("/groupmanage/save", {uuid, ...groupDetails});
export const manageCaretakers = (uuid, caretakers) => apiPostCall("/groupmanage/caretakers", {uuid, caretakers});